<template>
  <v-app>
    <!--<v-icon large color="green darken-2">mdi-domain</v-icon>-->

    <v-navigation-drawer
      app
      v-model="drawer"
      floating
      mobile-break-point="960"
      persistent
      width="360"
      dark
      class="d-print-none"
    >
      <v-img
        :src="require('@/assets/oct4.png')"
        alt="Oktapod"
        contain
        height="50"
      ></v-img>

      <v-divider class="mx-3 mb-3" />
      <v-list>
        <v-treeview
                :items="routes"
        >
          <template v-slot:label="{ item }">
            <v-list-item
                    :to="item.path"
                    :key="item.id"
                    :href=" 'href' in item ? item.href: null"
                    target=" 'target' in item ? item.target: '_self'"
            >
              <v-list-item-action>
                <v-icon>{{item.icon}}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-treeview>
      </v-list>

    </v-navigation-drawer>
    <v-app-bar
      app
      dark
      class="d-print-none"
    >
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        class="hidden-md-and-up"
      >

      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-toolbar-items>

        <v-btn
          v-if="isAuthenticated"
          @click="onLogout"
        >
          <v-icon left>mdi-exit-to-app</v-icon>
          <!--Выход-->
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <v-content
            id="print-body">
      <router-view></router-view>
<!--      {{ this.user.groups }}-->
    </v-content>
    <template v-if="errors">
      <v-snackbar
        :multi-line="true"
        :timeout="10000"
        color="error"
        @input="closeError"
        :value="true"
      >
        <div
          v-for="error in errors"
          :key="error"
        >
          <p>{{error}}</p>
        </div>

        <v-btn
          dark
          @click.native="closeError"
        >
          Close
        </v-btn>
      </v-snackbar>
    </template>
    <!--<v-footer app></v-footer>-->

  </v-app>

</template>

<script>
// import { mapGetters } from 'vuex'

import { getTreeView } from '@/common/tools'

export default {
  data () {
    return {
      drawer: true
    }
  },
  methods: {
    closeError () {
      this.$store.dispatch('common/clearError')
    },
    onLogout () {
      this.$store.dispatch('auth/logout')
        .then(() => {
          this.$router.push('/')
        }
        )
        .catch(error => {
          this.$store.dispatch('common/setError', error)
          this.$router.push('/')
        })
    },
    onUser () {
      this.$store.dispatch('auth/user')
        .then(() => {
          this.$router.push('/')
        }
        )
        .catch(error => {
          this.$store.dispatch('common/setError', error)
          this.$router.push('/')
        })
    }
  },
  computed: {
    // ...mapGetters('auth', [
    //   'isAuthenticated']),
    errors () {
      let errorsDict = this.$store.getters['common/errors']
      let errors2 = []
      let row = {}
      for (row in errorsDict) {
        errors2.push([row, errorsDict[row].join('\n')].join(': ').slice(0, 120))
        // console.log('errorsDict')
        // console.log([row, errorsDict[row].join('\n')].join(': ').slice(0, 100))
      }
      if (errors2.length === 0) {
        errors2 = null
      }
      return errors2
    },
    isAuthenticated () {
      return this.$store.getters['auth/isAuthenticated']
    },
    routes () {
      let links = []
      if (this.isAuthenticated) {
        links = getTreeView(this.$router.options.routes, this.user.groups)
        links.push({
          id: '/user',
          path: '/user',
          title: this.user.full_name,
          icon: 'mdi-account-circle'
        })
        for (let i in this.helpLinks) {
          let link = this.helpLinks[i]
          links.push({
            id: link.link,
            path: null,
            title: link.title,
            icon: 'mdi-book-open-variant',
            href: link.link,
            target: '_blank'
          })
        }
        for (let i in this.redmineLinks) {
          let link = this.redmineLinks[i]
          links.push({
            id: link.link,
            path: null,
            title: link.title,
            icon: 'mdi-help',
            href: link.link,
            target: '_blank'
          })
        }
      } else {
        links.push({
          id: '/login',
          path: '/login',
          title: 'Вход',
          icon: 'mdi-lock'
        }
        )
      }
      return links
    },
    user () {
      return this.$store.getters['auth/user']
    },
    helpLinks () {
      const links = {
        // 'Oktapod - Детсад - 101-ОЗ (МСК)': '1',
        // 'Oktapod - Детсад - 91-ОЗ (Компенсация)': '2',
        // 'Oktapod - ЖКУ - Реестр лицевых счетов': '3',
        // 'Oktapod - ЖКУ - Ручной ввод': '4',
        // 'Oktapod - Школы - Питание': '5',
        // 'Oktapod - Гемодиализ': '6',
        'Oktapod - КДН - ГИС ГМП': 'https://services.irksobes.ru/oktapod/tutorial/kdn_gis_gmp/index.html',
        'Oktapod - КДН - ГИС ГМП - бухгалтерия': 'https://services.irksobes.ru/oktapod/tutorial/gis_gmp_accounting/index.html'
      }
      let tutarials = []
      for (let i in this.user.groups) {
        let group = this.user.groups[i]
        if (group in links) {
          tutarials.push({ title: group, link: links[group] })
        }
      }

      return tutarials
    },
    redmineLinks () {
      const resources = {
        'Redmine. Oktapod. ЖКУ': {
          'link': 'https://services.irksobes.ru/redmine/projects/oktapod_gku/news',
          'groups': ['Oktapod - ЖКУ - Реестр лицевых счетов', 'Oktapod - ЖКУ - Ручной ввод']
        },
        'Redmine. Oktapod. Школы': {
          'link': 'https://services.irksobes.ru/redmine/projects/oktapod_school/news',
          'groups': ['Oktapod - Школы - Питание']
        },
        'Redmine. Oktapod. ГИС ГМП': {
          'link': 'https://services.irksobes.ru/redmine/projects/oktapod_gis_gmp/news',
          'groups': ['Oktapod - КДН - ГИС ГМП']
        },
        'Redmine. Oktapod. ГИС ГМП (бухгалтерия)': {
          'link': 'https://services.irksobes.ru/redmine/projects/oktapod_gis_gmp_accountant/news',
          'groups': ['Oktapod - КДН - ГИС ГМП - бухгалтерия']
        },
        'Redmine. Oktapod. Детсады': {
          'link': 'https://services.irksobes.ru/redmine/projects/oktapod_kindergarten/issues',
          'groups': ['Oktapod - Детсад - Реестры', 'Oktapod - Детсад - Реестры - Менеджеры']
        }
      }
      let urls = []
      for (let resourcesKey in resources) {
        let resource = resources[resourcesKey]
        // Ищем пересечение групп
        let intersectionGroups = resource['groups'].filter(x => this.user.groups.includes(x))
        if (intersectionGroups.length > 0) {
          urls.push({ title: resourcesKey, link: resource['link'] })
        }
      }
      return urls
    },
    listLoading () {
      return this.$store.getters['common/listLoading']
    }
  }

}
</script>

<style scoped>
  .pointer {
    cursor: pointer;
  }
  @media print {
    /*Применяем этот стиль для перекрытия тега v-navigation-drawer со свойством  mobile-break-point="960"
    !important - повышает приоритет стиля*/
    #print-body {
      padding: 0px !important;
    }
  }
</style>
